export const pastelChartColors = ["#a8cdeb", "#bdc6d3", "#e6d699", "#96b3d1", "#c8d2df", "#cfcca9", "#819ab8", "#aeb6c2"];

export function chartTheme(resolvedTheme) {
  const dark = resolvedTheme === "dark";
  return {
    line: dark ? "#a8cdeb" : "#0d9488",
    surface: dark ? "#202226" : "#ffffff",
    muted: dark ? "#a8b1bf" : "#71717a",
    grid: dark ? "#454b55" : "#f0f0f3",
    tooltip: dark ? "#e8ebef" : "#18181b",
    tooltipInk: dark ? "#181a1e" : "#ffffff",
  };
}